import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-progress-modal',
  templateUrl: './progress-modal.component.html',
  styleUrls: ['./progress-modal.component.css']
})
export class ProgressModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() showProgressBar: boolean = false;
  @Input() progressValue: number = 0;

  constructor(
    public activeModal: NgbActiveModal,
    private localizationService: LocalizationService
  ) { }

  ngOnInit(): void {
    // Set default values if not provided
    if (!this.title) {
      this.title = this.getCurrentLanguage() === 'ar' ? 'جاري المعالجة...' : 'Processing...';
    }
    if (!this.message) {
      this.message = this.getCurrentLanguage() === 'ar' ? 'يرجى الانتظار...' : 'Please wait...';
    }
  }

  getCurrentLanguage(): string {
    return this.localizationService.getCachedLanguage() ?? 'en';
  }
}
